document.addEventListener("DOMContentLoaded", function () {
  const banners = document.querySelectorAll(".usp-banner");

  if (!banners.length) return;

  banners.forEach((banner) => {
    const wrapper = banner.querySelector(".usp-banner__scroll");
    if (!wrapper) return;

    //const isMobile = () => window.matchMedia("(max-width: 988px)").matches;
    const sliderSpeed = parseFloat(wrapper.dataset.sliderSpeed) > 0 ? parseFloat(wrapper.dataset.sliderSpeed) : 6;
    const originalItems = Array.from(wrapper.children);
    if (!originalItems.length) return;

    let clonesAdded = false,
      scrollDistance = 0,
      offsetX = 0,
      lastTimestamp = null,
      rafId = null,
      autoplay = false;

    function updateScrollDistance() {
      scrollDistance = clonesAdded ? wrapper.scrollWidth / 2 : wrapper.scrollWidth || 1;
    }

    function toggleClones(add) {
      if (add && !clonesAdded) {
        originalItems.forEach((node) => {
          const clone = node.cloneNode(true);
          clone.classList.add("usp-banner__clone");
          wrapper.appendChild(clone);
        });
        originalItems.forEach((node) => {
          const clone = node.cloneNode(true);
          clone.classList.add("usp-banner__clone");
          wrapper.appendChild(clone);
        });
        originalItems.forEach((node) => {
          const clone = node.cloneNode(true);
          clone.classList.add("usp-banner__clone");
          wrapper.appendChild(clone);
        });
        clonesAdded = true;
      } else if (!add && clonesAdded) {
        wrapper.querySelectorAll(".usp-banner__clone").forEach((clone) => clone.remove());
        clonesAdded = false;
        offsetX = 0;
        lastTimestamp = null;
        wrapper.style.transform = "";
      }
      updateScrollDistance();
    }

    function animate(timestamp) {
      if (!autoplay) return;
      if (lastTimestamp === null) lastTimestamp = timestamp;
      const delta = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      offsetX -= (scrollDistance / (sliderSpeed * 1000)) * delta;
      if (offsetX <= -scrollDistance) offsetX += scrollDistance;

      wrapper.style.transform = `translateX(${offsetX}px)`;
      rafId = requestAnimationFrame(animate);
    }

    function playSlider() {
      /*
      if (!isMobile()) {
        autoplay = false;
        cancelAnimationFrame(rafId);
        toggleClones(false);
        return;
      }
      */
      toggleClones(true);
      autoplay = true;
      lastTimestamp = null;
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(animate);
    }

    function pauseSlider() {
      autoplay = false;
      cancelAnimationFrame(rafId);
    }

    // Pause/resume on user interaction
    ["touchstart", "mousedown", "pointerdown", "mouseenter"].forEach((evt) => wrapper.addEventListener(evt, pauseSlider, { passive: true }));
    ["touchend", "mouseup", "pointerup", "mouseleave"].forEach((evt) => wrapper.addEventListener(evt, playSlider, { passive: true }));

    // Recalculate and restart on resize
    window.addEventListener("resize", () => {
      if (originalItems.length > 3) {
        updateScrollDistance();
        playSlider();
      }
    });

    if (originalItems.length > 3) {
      updateScrollDistance();
      playSlider();
      toggleClones(true);
    } else {
      autoplay = false;
      rafId = requestAnimationFrame(animate);
      cancelAnimationFrame(rafId);
      toggleClones(false);
      wrapper.style.justifyContent = "center";
      wrapper.style.width = "100%";
    }
  });
});
